<template>
    <div class="center-container">
        <div class="main-info">
            <div class="header-container">
                <img :src="'/static/img'+developer.header" class="header-img" alt="" />
                <div class="edit-block" @click="showHeaders">修改头像</div>
            </div>
            <div class="info-container">
                <div class="info-half">
                    <div class="info-item">
                        <div>亲，这是您第&nbsp;<font color="red">{{loginTimes}}</font>&nbsp;次登录管理后台，</div>
                        <div class="offical-link" @click="gotoLog">查看登录日志</div>
                    </div>
                    <div class="info-item">
                        <div>用户名称：</div>
                        <div>{{developer.name}}</div>
                    </div>
                    <div class="info-item">
                        <div>注册时间：</div>
                        <div>{{developer.createTime}}</div>
                    </div>
                </div>
                <div class="info-half">
                    <div class="info-item">
                        <div>登录账号：</div>
                        <div>{{developer.mobile}}</div>
                    </div>
                    <div class="info-item">
                        <div>AppId：</div>
                        <div>{{developer.appid}}</div>
                        <div :data-clipboard-text="developer.appid" class="iconfont icon-fuzhi"></div>
                    </div>
                    <div class="info-item">
                        <div>Secret：</div>
                        <div v-if="showSecret">{{developer.appSecret}}</div>
                        <div v-else>{{developer.appSecretDot}}</div>
                        <div :data-clipboard-text="developer.appSecret" class="iconfont icon-fuzhi"></div>
                        <div class="eye iconfont icon-guan" v-if="showSecret" @click="changeShowSecret"></div>
                        <div class="eye iconfont icon-kai" v-else @click="changeShowSecret"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="edit-info">
            <div class="edit-half">
                <div class="edit-title">
                    <div class="iconfont icon-yonghu"></div>
                    <div class="title-label">修改基本信息</div>
                </div>
                <div class="edit-content">
                    <el-form ref="infoForm" :model="developer" :rules="infoRule" label-width="100px">
                        <el-form-item label="用户名称：" prop="name" required>
                            <el-input type="text" maxlength="20" v-model="developer.name"></el-input>
                        </el-form-item>
                        <el-form-item label="公司名称：" prop="companyName" required>
                            <el-input type="text" maxlength="32" v-model="developer.companyName"></el-input>
                        </el-form-item>
                        <el-form-item label="联系地址：" prop="address" required>
                            <el-input type="text" maxlength="64" v-model="developer.address"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="save">保存修改</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="edit-half">
                <div class="edit-title">
                    <div class="iconfont icon-mima"></div>
                    <div class="title-label">修改登录密码</div>
                </div>
                <div class="edit-content">
                    <el-form ref="pwdForm" :model="form" :rules="pwdRule" label-width="100px">
                        <el-form-item label="旧密码：" prop="oldPassword" required>
                            <el-input type="password" maxlength="32" v-model="form.oldPassword"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码：" prop="newPassword" required>
                            <el-input type="password" maxlength="32" v-model="form.newPassword"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="confirmPassword" required>
                            <el-input type="password" maxlength="32" v-model="form.confirmPassword"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="changePwd">确认修改</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog title="修改头像" :visible.sync="dialogVisible" :before-close="beforeClose" width="580px">
            <div class="choose-container">
                <div class="all-headers">
                    <div>
                        <img :src="'/static/img/headers/'+item" class="tochoose-header"
                            v-for="(item, index) in headers1" :key="index" alt="" @click="chooseHeader(item)">
                    </div>
                    <div class="headers2">
                        <img :src="'/static/img/headers/'+item" class="tochoose-header"
                            v-for="(item, index) in headers2" :key="index" alt="" @click="chooseHeader(item)">
                    </div>
                </div>
                <div class="preview-container">
                    <img :src="'/static/img'+currHeader" class="preview-header" alt="">
                    <div class="preview-label">头像预览</div>
                </div>
            </div>
            <div class="block-30"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="primary" @click="changeHeader">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import Clipboard from 'clipboard';

export default {
    data() {
        return {
            showSecret: false,
            clipboard: null,
            loginInfo: null,
            developer: null,
            token: null,
            loginTimes: 1,
            config: null,
            dialogVisible: false,
            headers1: ["default_trade.jpg", "default_colleagues.jpg", "default_beauty.jpg"],
            headers2: ["default_family.jpg", "default_friend.jpg", "default_handsome.jpg"],
            currHeader: null,
            infoRule: {
                name: [{ required: true, message: '请输入用户名称', trigger: 'blur' },
                { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }],
                companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' },
                { min: 2, max: 32, message: '长度在 2 到 32 个字符', trigger: 'blur' }],
                address: [{ required: true, message: '请输入联系地址', trigger: 'blur' },
                { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' }]
            },
            form: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            },
            pwdRule: {
                oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' },
                { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }],
                newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' },
                { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }],
                confirmPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' },
                { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }]
            }
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        this.developer = this.loginInfo.developer;
        this.token = this.loginInfo.token;
        this.loginTimes = this.loginInfo.loginTimes;
        this.config = {
            headers: {
                "Zonelink-Id": this.developer.id,
                "Zonelink-Username": this.developer.mobile,
                "Zonelink-Password": this.developer.password,
                "Zonelink-Token": this.token
            }
        };
        this.currHeader = this.developer.header;
    },
    mounted() {
        this.clipboard = new Clipboard(".icon-fuzhi");
        this.clipboard.on("success", () => {
            this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },
    methods: {
        changeShowSecret() {
            this.showSecret = !this.showSecret;
        },
        gotoLog() {
            this.$emit("clickMenu", 7);
        },
        showHeaders() {
            this.dialogVisible = true;
        },
        beforeClose() {
            this.dialogVisible = false;
            setTimeout(() => {
                this.currHeader = this.developer.header;
            }, 500);
        },
        chooseHeader(header) {
            this.currHeader = "/headers/" + header;
        },
        saveInfo(updateParams, msg, callback) {
            this.axios.put(this.$apiUrl + "/developbackend/setInfo", updateParams, this.config).then(res => {
                if (res.data.code == 403) {
                    this.$showErrorMsg(res.data.msg);
                    this.$router.push("/login");
                } else if (res.data.code != 200) {
                    this.$showSuccessMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg(msg);
                    for (let key in updateParams) {
                        this.developer[key] = updateParams[key];
                    }
                    if (res.data.data && res.data.data.token) {
                        this.loginInfo.token = res.data.data.token;
                        this.config.headers.password = this.developer.password;
                        this.config.headers.token = res.data.data.token;
                    }
                    sessionStorage.setItem("loginInfo", JSON.stringify(this.loginInfo));
                    if (callback) {
                        callback();
                    }
                }
            });
        },
        changeHeader() {
            if (this.currHeader == this.developer.header) {
                this.dialogVisible = false;
            } else {
                this.saveInfo({ header: this.currHeader }, "头像修改成功", () => {
                    this.$emit("changeHeader", this.currHeader);
                    this.dialogVisible = false;
                });
            }
        },
        save() {
            this.$refs["infoForm"].validate((valid) => {
                if (valid) {
                    let params = {
                        name: this.developer.name,
                        companyName: this.developer.companyName,
                        address: this.developer.address
                    };
                    this.saveInfo(params, "基本信息修改成功", () => {
                        this.$emit("changeName", this.developer.name);
                    });
                }
            });
        },
        changePwd() {
            this.$refs["pwdForm"].validate((valid) => {
                if (valid) {
                    if (this.form.oldPassword != this.developer.password) {
                        this.$showErrorMsg("旧密码输入错误");
                    } else if (this.form.newPassword != this.form.confirmPassword) {
                        this.$showErrorMsg("两次输入的密码不一致");
                    } else {
                        let params = {
                            password: this.form.newPassword
                        }
                        this.saveInfo(params, "基本信息修改成功");
                    }
                }
            });
        }
    },
    destroyed() {
        this.clipboard.destroy();
    }
}
</script>


<style scoped>
.center-container {
    display: flex;
    height: 100%;
    padding-right: 10px;
    flex-direction: column;
    overflow-y: hidden;
}

.main-info {
    padding: 30px;
    border: 1px solid #C0C6CC;
    display: flex;
}

.header-container {
    position: relative;
}

.header-img {
    width: 120px;
    border-radius: 10px;
}

.edit-block {
    opacity: 0.75;
    background: rgb(24, 24, 24);
    bottom: 0px;
    width: 120px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;
    user-select: none;
    position: absolute;
    font-size: 12px;
}

.choose-container {
    display: flex;
}

.all-headers {
    flex: 1;
}

.headers2 {
    margin-top: 15px;
}

.preview-container {
    text-align: center;
}

.preview-header {
    width: 120px;
}

.tochoose-header {
    width: 120px;
    cursor: pointer;
}

.tochoose-header+.tochoose-header {
    margin-left: 15px;
}

.preview-label {
    margin-top: 10px;
    text-align: center;
}

.info-container {
    margin-left: 30px;
    width: 100%;
    display: flex;
}

.info-half {
    flex: 1;
}

.info-item {
    display: flex;
    align-items: center;
}

.info-item+.info-item {
    margin-top: 30px;
}

.edit-info {
    flex: 1;
    margin-top: 15px;
    overflow-y: hidden;
    display: flex;
}

.edit-half {
    flex: 1;
    border: 1px solid #C0C6CC;
}

.edit-half+.edit-half {
    margin-left: 15px;
}

.edit-title {
    background-color: #F4F4F4;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: bold;
    user-select: none;
    display: flex;
    align-items: center;
}

.edit-content {
    padding: 30px;
}

.icon-fuzhi {
    margin-left: 10px;
    cursor: pointer;
}

.eye {
    margin-left: 10px;
    cursor: pointer;
}

.offical-link {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
    user-select: none;
}

.block-30 {
    height: 15px;
}

.title-label {
    margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// center.vue?0d52192c